import { forwardRef, useImperativeHandle, useState } from "react";
import { DropDownMenu } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const RuleDropdown = forwardRef(
  ({ onChange, componentRule, hasExtensionRule = false }, ref) => {
    const { t } = useTranslation(["Overlay"], {
      useSuspense: false,
    });

    const [rule, setRule] = useState(componentRule);

    var ruleDropdown = [
      {
        id: "rule-dropdown-date",
        text: t("ExtendDateModal.DropdownDate"),
        iconCss: rule == 2 ? "fa-solid fa-check" : "",
        onClick: () => {
          onChange?.(2);
        },
      },
    ];

    if (hasExtensionRule) {
      ruleDropdown.push({
        id: "rule-dropdown-rule",
        text: t("ExtendDateModal.DropdownRule"),
        iconCss: rule == 1 ? "fa-solid fa-check" : "",
        onClick: () => {
          onChange?.(1);
        },
      });
    }

    const handleRuleSelectMenuItem = (args) => {
      args?.onClick?.();
    };

    useImperativeHandle(
      ref,
      () => ({
        getRule: () => rule,
        setRule: () => setRule,
      }),
      []
    );

    return (
      <div className="d-flex justify-content-start align-items-center gap-2 rule-extended-date-modal">
        <div className="my-4 fs-16">{t("ExtendDateModal.ApplyExtension")}</div>
        <div>
          <DropDownMenu
            id={"dd_rule_extended-date-modal"}
            select={handleRuleSelectMenuItem}
            items={ruleDropdown}
          >
            <div className="fw-600">
              {rule == 1
                ? t("ExtendDateModal.DropdownRule")
                : t("ExtendDateModal.DropdownDate")}
            </div>
          </DropDownMenu>
        </div>
      </div>
    );
  }
);
